import { ApiFactoryClassType } from './factory';
import { SearchResultResponse } from './types/search';

const search = (factory: ApiFactoryClassType) => ({
    executeSearch: async (
        query: string,
        type: string = 'all',
        filePoolId: string | undefined = undefined,
        contentName: string | undefined = undefined,
        limit: number = 15,
        offset: number = 0,
    ): Promise<SearchResultResponse | null> => {
        const session = factory.getSession();
        if (!session || !session.auth || !session.auth.access_token) {
            return Promise.reject('no active session');
        }
        try {
            const response = await fetch(
                new URL(
                    `/api/search/${query}?type=${type}&limit=${limit}&offset=${offset}${filePoolId ? `&filter[filePool]=${filePoolId}` : ''}${contentName ? `&filter[contentName]=${contentName}` : ''}`,
                    factory.getApiHost(),
                ),
                {
                    method: 'GET',
                    headers: {
                        Authorization: 'Bearer ' + session.auth.access_token,
                    },
                    mode: 'cors',
                },
            );

            if (!response.ok) {
                factory.onError(response);
            }

            return response.json().catch(() => null);
        } catch (e) {
            factory.onNetworkError();
            return null;
        }
    },
});

export default search;
